import { useEffect } from 'react';

import { useSyncRef } from '../syncRef';

export function useKeyPress(key: string, handler: (e: KeyboardEvent) => void) {
  const cache = useSyncRef({
    handler,
  });

  useEffect(() => {
    const keyHandler = (event: KeyboardEvent) => {
      // to do: more configs related to preventDefault, combos, etc
      if (event.key === key) {
        event.preventDefault();

        cache.current.handler(event);
      }
    };

    document.addEventListener('keydown', keyHandler);

    return () => document.removeEventListener('keydown', keyHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
